import { RouteObject } from "react-router";

import { Dashboard } from "@pages/dashboard/Dashboard/Dashboard.page";
import { GenerateReport } from "@pages/dashboard/GenerateReport/GenerateReport.page";
import { routes } from "@pages/routes";

export const dashboardRoutes = [
  {
    path: routes.portal.dashboard.index.$path(),
    handle: {
      breadcrumb: {
        title: "Dashboard",
      },
    },
    children: [
      {
        index: true,
        Component: Dashboard,
      },
      {
        path: routes.portal.dashboard.generateReport.$path(),
        Component: GenerateReport,
      },
    ],
  },
] satisfies RouteObject[];
